import { WizardContextState, WizardScreen } from '../Context/Type'

export const isPrimaryFullWidthLayout = (context: WizardContextState | null): boolean => {
  if (context) {
    const { matches } = context
    if (
      matches('idle') ||
      matches(WizardScreen.bookingSelector) ||
      matches(WizardScreen.closed) ||
      matches(WizardScreen.success) ||
      matches(WizardScreen.slotAlreadyTaken) ||
      matches(WizardScreen.failed)
    ) {
      return true
    }
  }
  return false
}

export const isPrimaryCenterLayout = (context: WizardContextState | null): boolean => {
  if (context) {
    const { matches } = context
    if (
      matches('idle') ||
      matches(WizardScreen.closed) ||
      matches(WizardScreen.success) ||
      matches(WizardScreen.slotAlreadyTaken) ||
      matches(WizardScreen.failed) ||
      matches(WizardScreen.noBookableSlot)
    ) {
      return true
    }
  }
  return false
}

export const shouldShowHeader = (context: WizardContextState | null): boolean => {
  if (context) {
    const { matches } = context
    if (
      matches('idle') ||
      matches(WizardScreen.closed) ||
      matches(WizardScreen.success) ||
      matches(WizardScreen.slotAlreadyTaken) ||
      matches(WizardScreen.failed) ||
      matches(WizardScreen.noBookableSlot)
    ) {
      return false
    }
  }
  return true
}

export const shouldShowBack = (context: WizardContextState | null): boolean => {
  if (context) {
    const { matches } = context
    if (
      matches('idle') ||
      matches(WizardScreen.bookingSelector) ||
      matches(WizardScreen.closed) ||
      matches(WizardScreen.success) ||
      matches(WizardScreen.slotAlreadyTaken) ||
      matches(WizardScreen.failed) ||
      matches(WizardScreen.projectSale) ||
      matches(WizardScreen.projectRent) ||
      matches(WizardScreen.applicantMain) ||
      matches(WizardScreen.noBookableSlot) ||
      matches(WizardScreen.projectPro)
    ) {
      return false
    }
  }
  return true
}
